import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SessionItemRow, SessionItemsProvider } from '../../../sessions/providers/sessionItems-provider';
import { SessionRow, SessionsProvider } from '../../../sessions/providers/sessions-provider';
import { SessionsGeneralPanelComponent } from '../../../sessions/components/session-general-panel/session-general-panel';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OrganizationsNavigationProvider } from '../../../organizations/providers/navigation-provider';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, NgForOf, NgIf } from '@angular/common';
import { MatMiniFabButton } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ShareComponent } from "../../../chat/share/share.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { SessionBlocComponent } from "../../../sessions/components/session-bloc/session-bloc";
import { SessionCommentComponent } from "../../../sessions/components/session-comment/session-comment";
import { SessionRestComponent } from "../../../sessions/components/session-rest/session-rest";
import {
  StopwatchComponent
} from "../../../sessions/components/session-exercice-duration/stopwatch/stopwatch.component";
import { Organization } from "../../../common/models/organization";
import { Session } from "../../../common/models/session";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { User } from "../../../common/models/user";
import { MatIconModule } from "@angular/material/icon";
import { forkJoin, map } from "rxjs";
import { Library } from "../../../common/models/library";

@Component({
  selector: 'app-mobile-session-view',
  providers: [],
  styleUrls: ['./mobile.session-view.component.scss'],
  standalone: true,
  imports: [
    MatMiniFabButton,
    MatTooltipModule,
    ShareComponent,
    TranslateModule,
    SessionsGeneralPanelComponent,
    NgIf,
    FlexLayoutModule,
    SessionBlocComponent,
    NgForOf,
    SessionCommentComponent,
    SessionRestComponent,
    StopwatchComponent,
    MatIconModule,
  ],
  templateUrl: './mobile.session-view.component.html'
})
export class MobileSessionViewComponent implements OnInit {
    @Input() public set session(session: Session) {
        this._session = session;
    }
    public get session() {
        return this._session;
    }

    @Input() public organization: Organization = {} as Organization;
    @Input() public athleteUser: User = {} as User;
    @Input() public sessionId: number | null = null;

    public sessionItems: SessionItemRow[] = [];
    public sessionRow: SessionRow = {} as SessionRow;
    selectedStopwatchSessionIndex: number | undefined;
    selectedStopwatchExerciseIndex: number | undefined;
    stopwatchData: any;
    stopwatchDisplay = true;

    @ViewChild(SessionsGeneralPanelComponent, {static: false}) public generalPanel: SessionsGeneralPanelComponent = {} as SessionsGeneralPanelComponent;
    private _session: Session = {} as Session;

    constructor(
        private _translater: TranslateService,
        private _sessionsProvider: SessionsProvider,
        private _sessionItemsProvider: SessionItemsProvider,
        private _organizationNavigation: OrganizationsNavigationProvider,
        private _router: Router,
        private _route: ActivatedRoute,
        private _utils: UtilsProvider,
        private _location: Location
    ) { }

    public ngOnInit(): void {
        this.loadData();
    }

    public getBlocNumber(sessionItemRow: SessionItemRow): number {
        const allBlocs: SessionItemRow[] = this._utils.findManyIn([SessionItemsProvider.TYPE_BLOC], this.sessionItems, 'type');

        return allBlocs.indexOf(sessionItemRow) + 1;
    }

    public onClickBackButton() {
        this._location.back();
    }

    public onOpenStopwatch(selectedStopwatchSessionIndex: number | null, [selectedStopwatchExerciseIndex, exercise]: any) {
        this.stopwatchDisplay = true;
        this.stopwatchData = exercise;
        this.selectedStopwatchSessionIndex = selectedStopwatchSessionIndex ?? undefined;
        this.selectedStopwatchExerciseIndex = selectedStopwatchExerciseIndex;
    }

    public onCloseStopwatch() {
        this.stopwatchDisplay = false;
        // this.stopwatchData = null;
    }

    private loadData(): void {
      forkJoin([
        this._sessionsProvider.getSessionRow({organization: this.organization!, session: this.session, filled: true}),
        this._sessionItemsProvider.buildSessionItemRowsFromSession(this.organization, this.session),
      ]).pipe(
        map(([sessionRow, sessionItems]: [SessionRow, SessionItemRow[]]) => {
          this.sessionItems = sessionItems;
          this.sessionRow = sessionRow;
        }),
      ).subscribe();
    }
}
